import { render, staticRenderFns } from "./MedicalSpecialities.vue?vue&type=template&id=25a763f9&scoped=true"
import script from "./MedicalSpecialities.vue?vue&type=script&lang=js"
export * from "./MedicalSpecialities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a763f9",
  null
  
)

export default component.exports